import { useState, useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { useConfigContextInfo } from '../../contexts/ConfigContext'
import PVTWorkout from './PVTWorkout'
import usePVT from '../../hooks/usePVT'
import { PAGES } from './pages'
import PVTInstructions from './PVTInstructions'
import PVTSetting from './PVTSetting'
import { useNavbar } from '../../contexts/NavbarContext'
import { useTranslation } from "react-i18next"
import { UAParser } from "ua-parser-js"

const PVTWrapper = () => {
  const config = useConfigContextInfo()
  const [page, setPage] = useState(PAGES.INSTRUCTIONS)
  const [pvtId, setPvtId] = useState(null)
  const { data, startPVT } = usePVT()
  const { enqueueSnackbar } = useSnackbar()
  const { show, hide } = useNavbar()
  const { t } = useTranslation('common')

  useEffect(() => {
    if (page !== PAGES.WORKOUT) {
      show()
    } else {
      hide()
    }

    if (page === PAGES.SETTING) {
      const pvtStart = async () => {
        const parser = new UAParser()
        const result = parser.getResult()

        const deviceType = result.device.type || "desktop"
        const deviceModel = result.device.model || "unknown"
        const deviceOS = `${result.os.name || "unknown"} ${result.os.version || ""}`
        const { status, data: pvtData } = await startPVT({
          device_model: deviceModel,
          device_os: deviceOS,
          is_mobile: deviceType === "mobile",
          is_desktop: deviceType === "desktop",
          is_tablet: deviceType === "tablet"
        })

        if (status === 'failure') {
          const snackbar = () =>
            enqueueSnackbar(
              t('pvt.start_error'),
              {
                variant: 'error',
                anchorOrigin: { horizontal: 'right', vertical: 'top' },
              },
            )

          snackbar()

          setTimeout(() => {
            setPage(PAGES.INSTRUCTIONS)
          }, [1500])

          return
        }

        setPvtId(pvtData?.pvtId)
        setPage(PAGES.WORKOUT)
      }

      pvtStart()
    }
  }, [page])

  return (
    <>
      {page === PAGES.INSTRUCTIONS && (
        <PVTInstructions
          status={data?.status}
          blockedUntil={data?.blockedUntil}
          duration={config.pvtDuration}
          onStart={() => setPage(PAGES.SETTING)}
        />
      )}
      {page === PAGES.SETTING && <PVTSetting />}
      {page === PAGES.WORKOUT && (
        <PVTWorkout
          onClose={() => setPage(PAGES.INSTRUCTIONS)}
          pvtId={pvtId}
          testTime={config.pvtDuration * 1000 * 60}
        />
      )}
    </>
  )
}

export default PVTWrapper
